export const getSelectedOrFirstCustomerId = (
  customerIds?: Array<string>,
  selectedCustomerId?: string,
) => {
  if (selectedCustomerId && customerIds?.includes(selectedCustomerId))
    return selectedCustomerId;
  return customerIds?.at(0);
};
